/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import {
  Button, Typography, CircularProgress, Select, InputBase, MenuItem,
} from '@material-ui/core';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { DownChevronSelectToggleItems } from './DownChevronSelectToggle';
import { checkIsAuthorized, checkIsLocationAdmin } from '../../utils/AuthorizationChecks';
import { resourceFormStyle, commonResourceStyle, displayResourceStyles } from '../../css/style';
import * as utilFunctions from '../../utils/Functions';
import CraverBreadCrumb from './CraverBreadCrumb';
import VersionAndBuildNumber from './VersionAndBuildNumber';
import { taxActionsDisabled, taxActionsEnabled } from '../../data/Constants';

const styles = resourceFormStyle();
const commonStyles = commonResourceStyle();
class CreateAndEditWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedAction: '',
      isActionSelectOpen: false,
    };
  }

  toggleActionSelect = targetState => () => this.setState(
    { isActionSelectOpen: targetState },
  );

  headerText = (isApplyTaxes, type, resourceTitle) => {
    if (isApplyTaxes) {
      return 'Apply Taxes';
    }
    if (type === 'edit') {
      return `Edit ${resourceTitle}`;
    }
    return `Create ${resourceTitle}`;
  }

  render() {
    const {
      match,
      type,
      admin,
      shouldDisableSaveButton,
      onClickApplyChanges,
      onBack,
      children,
      isTaxes,
      isEditTaxes,
      isApplyTaxes,
      onActionDropdownChange,
      classes,
      taxDisabled,
    } = this.props;
    const {
      resource, subResource, resourceId, subResourceId,
    } = match.params;
    const { selectedAction, isActionSelectOpen } = this.state;

    const resourceForCheckIsAuthorized = resource === 'products' ? 'menu' : resource;
    const attemptedAction = type === 'create' ? 'add' : 'edit';
    const canAccountCreateOrEditResource = checkIsAuthorized(
      admin, resourceForCheckIsAuthorized, subResource, attemptedAction,
    );

    if (!canAccountCreateOrEditResource) {
      return (
        <Redirect
          to={{
            pathname: '/unauthorized',
            state: { from: { resource, subResource } },
          }}
        />
      );
    }
    const resourceName = subResource || resource;
    const resourceTitle = utilFunctions.capitalizeTheFirstLetterOfEachWord(
      utilFunctions.depluralizeResourceName(resourceName),
    );
    const isLocationAdmin = checkIsLocationAdmin(admin);
    const taxActions = taxDisabled ? taxActionsDisabled : taxActionsEnabled;
    const authorizedActions = Object.entries(taxActions).filter(
      ([key, config]) => !isLocationAdmin || config.isUsableByLocationAdmins,
    );
    return (
      <div style={isTaxes ? styles.containerTax : styles.container}>
        <div style={commonStyles.resourceHeader}>
          <div style={isTaxes ? commonStyles.resourceNameTaxes : commonStyles.resourceName}>
            <Typography style={commonStyles.resourceName}>
              {this.headerText(isApplyTaxes, type, resourceTitle)}
            </Typography>
          </div>
          {
            isTaxes
            && (
              <div style={commonStyles.editTaxesButtonsContainer}>
                {
                  isEditTaxes && !isApplyTaxes
                  && (
                    <Select
                      open={isActionSelectOpen}
                      onOpen={this.toggleActionSelect(true)}
                      onClose={this.toggleActionSelect(false)}
                      value={selectedAction}
                      style={commonStyles.taxActionsStyles}
                      input={<InputBase />}
                      displayEmpty
                      onChange={onActionDropdownChange}
                      classes={{
                        root: classes.bulkActionInnerSelectItems,
                        selectMenu: classes.bulkActionSelectMenuItems,
                        select: classes.taxSelect,
                      }}
                      IconComponent={
                        DownChevronSelectToggleItems(this.toggleActionSelect(!isActionSelectOpen))
                      }
                    >
                      <MenuItem value="">Actions</MenuItem>
                      {
                        checkIsAuthorized(admin, resource, resourceName, 'edit')
                        && (
                          authorizedActions.map(
                            ([actionName, config]) => (
                              <MenuItem value={actionName}>
                                {config.title}
                              </MenuItem>
                            ),
                          )
                        )
                      }
                    </Select>
                  )
                }
                <div style={styles.taxesActionsMargin} />
                <Button
                  variant='contained'
                  onClick={onBack}
                  style={styles.backTaxesButton}
                >
                  Back
                </Button>
                <div style={styles.taxesActionsMargin} />
                <Button
                  variant='contained'
                  onClick={onClickApplyChanges}
                  style={styles.saveTaxesButton}
                >
                  Apply
                </Button>
              </div>
            )
          }
          <div style={
            isTaxes
              ? commonStyles.breadcrumbContainerTax
              : commonStyles.breadcrumbContainer
            }
          >
            <CraverBreadCrumb
              resource={resource}
              resourceId={resourceId}
              resourceName={this.state.name}
              subResource={subResource}
              subResourceId={subResourceId}
            />
          </div>
        </div>
        {children}
        <div style={styles.bottomBelowPaperContainer}>
          <VersionAndBuildNumber
            containerStyle={
              isTaxes
                ? styles.bottomLeftBelowPaperSubContainerTax
                : styles.bottomLeftBelowPaperSubContainer
            }
          />
          {
            !isTaxes
            && (
              <div style={styles.applyChangesButtonSolidContainer}>
                <Button
                  variant='contained'
                  disabled={shouldDisableSaveButton}
                  onClick={onClickApplyChanges}
                  style={styles.applyChangesButtonSolid}
                >
                  {this.props.loading ? <CircularProgress style={styles.applyChangesButtonSpinner} /> : 'APPLY CHANGES'}
                </Button>
              </div>
            )
          }
        </div>
      </div>
    );
  }
}

CreateAndEditWrapper.propTypes = {
  shouldDisableSaveButton: PropTypes.bool,
  onClickApplyChanges: PropTypes.func.isRequired,
  match: PropTypes.objectOf(PropTypes.any).isRequired,
  type: PropTypes.string.isRequired,
  admin: PropTypes.objectOf(PropTypes.any).isRequired,
  onBack: PropTypes.func,
  children: PropTypes.arrayOf(PropTypes.any),
  isTaxes: PropTypes.bool,
  isEditTaxes: PropTypes.bool,
  isApplyTaxes: PropTypes.bool,
  onActionDropdownChange: PropTypes.func,
  classes: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)).isRequired,
  loading: PropTypes.bool.isRequired,
  taxDisabled: PropTypes.bool,
};

CreateAndEditWrapper.defaultProps = {
  shouldDisableSaveButton: false,
  onBack: null,
  children: null,
  isTaxes: false,
  isEditTaxes: false,
  isApplyTaxes: false,
  onActionDropdownChange: null,
  taxDisabled: false,
};

export default withStyles(displayResourceStyles)(CreateAndEditWrapper);
